import listTemplate from './list/list.pug';
import formTemplate from './form/form.pug';
import viewTemplate from './view/view.pug';

'use strict';

export default ['$stateProvider', function routes($stateProvider) {
  $stateProvider
    .state('group.view.settings.memberAttributeType', {
    // /context/:ctxId/groups/:groupId/memberattributes
    // :ctxId = ancestor/context group, :groupId = group
      url: '/memberattributetypes',
      abstract: true,
      template: '<ui-view />'
    })
    .state('group.view.settings.memberAttributeType.list', {
      url: '',
      template: listTemplate,
      controller: 'MemAtrTypeListCtrl',
      controllerAs: 'mavm',
      authenticate: true
    })
    .state('group.view.settings.memberAttributeType.new', {
      url: '/new',
      template: formTemplate,
      controller: 'MemAtrTypeFormCtrl',
      controllerAs: 'mavm',
      authenticate: true
    })
    .state('group.view.settings.memberAttributeType.view', {
      url: '/:maId',
      template: viewTemplate,
      controller: 'MemAtrTypeViewCtrl',
      controllerAs: 'mavm',
      authenticate: true
    })
    .state('group.view.settings.memberAttributeType.edit', {
      url: '/:maId/edit',
      template: formTemplate,
      controller: 'MemAtrTypeFormCtrl',
      controllerAs: 'mavm',
      authenticate: true
    });
}];
